import type { FC } from 'react'
import type { ERC20Names } from '@g4g/wallet-modal/types'
import { WalletModalError } from '@g4g/wallet-modal/hooks/wallet/types'
import WalletPopupOverlay from '../../../../../components/shared/wallet/WalletPopupOverlay'
import { MinimalistButton } from '@g4g/ui/src/internal/buttons/MinimalistButton'

const CheckoutPaymentTxOverlay: FC<{
  paymentOption: ERC20Names
  loading: boolean
  error?: WalletModalError
  closeOverlay: () => void
}> = ({ paymentOption, loading, error, closeOverlay }) => (
  <WalletPopupOverlay
    action="transaction"
    paymentOption={paymentOption}
    loading={loading}
    error={error}
  >
    <MinimalistButton
      props={{
        mainColor: '#ccc',
        buttonText: 'Cancel',
        onClick: () => closeOverlay(),
      }}
    />
  </WalletPopupOverlay>
)

export default CheckoutPaymentTxOverlay
